'use client';
import React from 'react';
import { useWatch } from "react-hook-form";
import Overlay from "../shared/Overlay.jsx";
import Wrapper from "../shared/Wrapper.jsx"
import useMioForm from "../shared/useMioForm.jsx";
import { useState, useRef, useEffect, useMemo } from "react";
import searchFn from "../utils/searchFn.js";
import { PiCaretDown } from "react-icons/pi";

function MioSelect(p) {
    const { mioID, field, isDirty, isInvalid, isTouched, setValue } = useMioForm(p.name, p.required);
    // Step: watch the value, so we can populate the dummy input
    const value = useWatch({ name: p.name });
    // Step: focusRef is the dummy input field, which is used instead of the normal <select>
    const focusRef = useRef();
    const containerRef = useRef();
    // Step: because the options list is searchable, we need a separate state
    // const [filteredOptions, setFilteredOptions] = useState([]);
    const [search, setSearch] = useState('');
    const searchRef = useRef();
    // Step: keep the selected option in a Ref, so it is easier to scroll it into view
    const selectedRef = useRef();
    // Step: handle the overlay
    const [open, setOpen] = useState(false);
    const anchorRef = useRef();
    // Step: handle overlay states
    useEffect(() => {
        if (open) {
            searchRef?.current.focus();
            setTimeout(() => {
                // selectedRef.current?.scrollIntoView({ behavior: 'auto', block: 'start' });
                const containerRect = containerRef.current?.getBoundingClientRect();
                const selectedRect = selectedRef.current?.getBoundingClientRect();

                const offset = selectedRect.top - containerRect.top;

                containerRef.current?.scrollTo({
                    top: offset,
                    behavior: 'auto',
                });
            }, 10);
        }
        if (!open) {
            setSearch('');
        }
    }, [open])

    const [options, setOptions] = useState([]);
    useEffect(() => {
        const newOptions = [["", '- No Selection -'], ...p.options];
        setOptions(newOptions);
    }, [p.options]);
    // Step: When either the options, the value or search changes, generate the list and populate the dummy
    const filteredOptions = useMemo(() => {
        const tValue = value || '';
        return options.filter(f => searchFn(search, [f[1]])).map(m => {
            const item = {
                value: m[0],
                display: m[1]
            }
            if (m[0] === tValue) {
                item.selected = true;
                item.ref = selectedRef;
            }
            return item;
        })
    }, [options, value, search, focusRef]);

    useEffect(() => {
        const tValue = value || '';
        const sel = options.find(f => f[0] === tValue);
        focusRef.current.value = sel ? sel[1] ?? '' : '';
    }, [value, options]);
    // useEffect(() => {
    //     const tValue = value || '';
    //     setFilteredOptions(options.filter(f => searchFn(search, [f[1]])).map(m => {
    //         const item = {
    //             value: m[0],
    //             display: m[1]
    //         }
    //         if (m[0] === tValue) {
    //             item.selected = true;
    //             item.ref = selectedRef;
    //         }
    //         return item;
    //     }));

    //     // const sel = options[selectRef.current.selectedIndex - 1];
    //     const sel = options.find(f => f[0] === tValue);
    //     focusRef.current.value = sel ? sel[1] ?? '' : '';
    // }, [options, value, search]);

    const selectHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        focusRef.current.blur();
        setOpen(true)

        // setOpen(true);
    }

    // refocus the element when the portal closes
    const portalClose = () => {
        focusRef.current.focus();
        setOpen(false);

    }

    // select first element and then trigger portal close
    const keydownHandler = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            if (filteredOptions.length === 1) {
                field.onChange(filteredOptions[0].value);
                portalClose();
            }
        }
    }

    // set selected value and trigger portal close
    const optionClick = (row) => {
        field.onChange(row.value);
        portalClose();
    }


    return (
        <>
            <Wrapper {...p} mioID={mioID} isInvalid={isInvalid} isTouched={isTouched} isDirty={isDirty}>
                {p.options ?
                    <div className="mtwi" ref={anchorRef}>
                        {/* Hidden Select */}
                        {/* <select
                            {...field}
                            value={field.value ?? ''}
                            ref={(el) => {
                                field.ref(el);  // RHF needs this
                                selectRef.current = el;  // You store it too
                            }}
                            style={{ display: 'none' }}
                        >
                            {options.map((row, index) => (
                                <option key={index} value={row[0]}>{row[1]}</option>
                            ))}
                        </select> */}
                        {/* Dummy Input */}
                        <input
                            className={`
                                mio-form-control-input
                                ${isInvalid ? 'mio-form-control-input-invalid ' : ''}
                                `}
                            ref={focusRef} readOnly
                            onMouseDown={selectHandler}
                            onKeyDown={(e) => { if (e.key === 'Enter') setOpen(true) }}
                            style={{ caretColor: 'transparent', cursor: 'pointer' }}
                        />
                        <div className="mio-form-control-icon" onClick={selectHandler}>
                            <PiCaretDown />
                        </div>
                    </div>
                    : ''}
            </Wrapper>
            {open && <Overlay onClose={portalClose} anchorRef={anchorRef}>
                {filteredOptions ?
                    <div className="mtws">
                        <div className="mtws-search">
                            <input type="text"
                                className="mio-form-select-search-input"
                                ref={searchRef}
                                value={search ?? ''}
                                onChange={(e) => setSearch(e.target.value)}
                                onClick={(e) => { e.stopPropagation() }}
                                onKeyDown={keydownHandler}
                                placeholder="Search"
                                tabIndex="-1"
                            />
                        </div>
                        <div className="mtws-options" ref={containerRef}>
                            {filteredOptions.map((row, index) => (
                                <div className={`
                                    mtws-option
                                    ${row.selected ? 'mtws-selected' : ''}
                                    `}
                                    key={index}
                                    ref={row.ref}
                                    onClick={() => optionClick(row)}>
                                    {row.display}
                                </div>
                            ))}
                        </div>
                    </div>
                    : ''}
            </Overlay>}
        </>

    )
}
export default MioSelect